import { useTranslation } from "react-i18next";
import { TicketStatus } from "../helpCenter.service";

const classNameMap: Record<TicketStatus, string> = {
  waiting_for_response: "status-waiting",
  in_progress: "status-progress",
  resolved: "status-resolved",
};

const TicketStatusBadge = ({ status }: { status: TicketStatus }) => {
  const { t } = useTranslation("helpCenter");
  const labelMap: Record<TicketStatus, string> = {
    waiting_for_response: t("status.waitingForResponse"),
    in_progress: t("status.inProgress"),
    resolved: t("status.resolved"),
  };
  const label = labelMap[status] ?? status;
  const className = classNameMap[status] ?? "status-waiting";
  return <span className={`ticket-status ${className}`}>{label}</span>;
};

export default TicketStatusBadge;
